import {createAction} from 'redux-actions';

// unique key namespace used by combineReducers.
// By convention it will match the directory structure to
// make it easy to locate the src.
// Also action types will prefix with the capitalized version
export const key = 'socket';

// action creators
export const wsConnect = createAction(`${key}/WS_CONNECT`, (user) => ({
    user
  })
);
export const wsDisconnect = createAction(`${key}/WS_DISCONNECT`);
export const wsReconnect = createAction(`${key}/WS_RECONNECT`, (user) => ({
    user
  })
);

export const wsSuccess = createAction(`${key}/WS_SUCCESS`);
export const wsError = createAction(`${key}/WS_ERROR`, (error, user) => ({
    error,
    user
  })
);

export const wsSubscribe = createAction(`${key}/SUBSCRIBE`, (user) => ({
    user
  })
);

export const wsUnsubscribe = createAction(`${key}/UNSUBSCRIBE`, (key) => ({
    key
  })
);

export const wsSetSubscription = createAction(`${key}/SET_SUBSCRIPTION`, (value) => ({
    value
  })
);

export const wsListen = createAction(`${key}/LISTEN`, (key, subject, callback) => ({
    key,
    callback,
    subject
  })
);

export const wsUnlisten = createAction(`${key}/UNLISTEN`, (key, subject) => ({
    key,
    subject
  })
);

export const wsUnlistenAll = createAction(`${key}/UNLISTEN`);

export default {
  wsConnect,
  wsDisconnect,
  wsReconnect,
  wsSuccess,
  wsError,
  wsSubscribe,
  wsUnsubscribe,
  wsListen,
  wsUnlisten,
  wsUnlistenAll,
  wsSetSubscription
};



// WEBPACK FOOTER //
// ./src/util/redux/socket/actions.js